import { FC } from 'react'
import BaseWarning from './BaseWarning'

const ShowingTransferWarning: FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <BaseWarning
      onClose={onClose}
      message="This showing preference change will generate a listing transfer of all your listings, including active listings, to the new provider. You will need to manually capture current appointment data on your active listings and manually reenter that data into the new showing application. Please allow for up to 30 minutes for your listings to transfer."
    />
  )
}

export default ShowingTransferWarning
